import { VFC } from "react";

import SimpleSearchView from "components/SimpleSearchView";
import { useTranslation } from "react-i18next";
import FiltersAppBar from "utils/layout/FiltersAppBar";

interface CarrierIntegrationsFilterBarViewProps {
  search: string;
  setSearch: (search: string) => void;
}

const CarrierIntegrationsFilterBarView: VFC<CarrierIntegrationsFilterBarViewProps> = ({ search, setSearch }) => {
  const { t } = useTranslation(["shipper"]);
  return (
    <FiltersAppBar>
      <SimpleSearchView search={search} placeholder={t("shipper:searchCarriers")} onChange={setSearch} />
    </FiltersAppBar>
  );
};

export default CarrierIntegrationsFilterBarView;
